import { Address } from '@ravago/shared/page-data/models/elements/address.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { MultiLineText } from '@ravago/shared/radiance/components/typography/components/MultiLineText/MultiLineText';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { LeadTimeMessage } from '../../../../../../shared/lead-time-message/lead-time-message';

interface AddressProps {
   address: Address;
   timeframe?: string;
   leadTimeEnabled: boolean;
   isMtsLocalAddress: boolean;
}

interface DeliveryAreaProps {
   country: string;
   city: string;
   postalCode: string;
   leadTimeEnabled: boolean;
   timeframe?: string;
   isMtsLocalAddress: boolean;
}

type Props = AddressProps | DeliveryAreaProps;

export const RfqDeliveryInfo = ({ timeframe, leadTimeEnabled, isMtsLocalAddress = false, ...props }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="md">
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.delivery-area')}
            </Typography>
            <Box gap="2xs" items="center">
               {'address' in props ? (
                  <MultiLineText text={props.address.htmlFormat} lineBreak="<br>" />
               ) : (
                  <>
                     <Typography variant="body">
                        {props.postalCode} {props.city}
                     </Typography>
                     <Typography variant="body" component="p">
                        {props.country}
                     </Typography>
                  </>
               )}
            </Box>
         </Box>
         {leadTimeEnabled && <LeadTimeMessage hasMtsLocal={isMtsLocalAddress} />}
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.delivery-preference')}
            </Typography>
            <Box gap="2xs" items="center">
               <Typography component="span" variant="body">
                  {timeframe ?? ''}
               </Typography>
            </Box>
         </Box>
      </Box>
   );
};
